import React, { FunctionComponent } from "react";
import NumberFormat from "react-number-format";
import { NumberFormatProps } from "react-number-format";

export interface Props {}

export const NumberInput: FunctionComponent<NumberFormatProps> = ({ ...props }) => {
  return (
    <NumberFormat
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={"."}
      allowedDecimalSeparators={[",", "."]}
      {...props}
    />
  );
};

NumberInput.displayName = "NumberInput";
